/**
 * Product card slides - Updates the image dots according to the swipe position.
 * The swipe is native (CSS scroll snap), mobile only. On desktop, the slides don't have a box, so the track doesn't scroll.
 * Only the visible slides/dots are counted, since the Lifestyle view hides the image 2 slide (the card image already shows it).
 * Used in the product cards with the mobile swipe (Collection, Search & Featured collection grid)
 */
if (!customElements.get('product-card-slides')) {
  class ProductCardSlides extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slides-track]');
      this.dots = [...this.querySelectorAll('[data-slide-dot]')];
      if (!this.track || this.dots.length < 2) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });
      document.addEventListener('card-overview:view-change', () => this.onViewChange(), { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;

      requestAnimationFrame(() => {
        this.ticking = false;
        this.updateDots();
      });
    }

    // go back to the first slide, since the number of slides changes with the view
    onViewChange() {
      this.track.scrollLeft = 0;
      this.updateDots();
    }

    updateDots() {
      const visibleDots = this.dots.filter((dot) => dot.offsetParent !== null);
      if (!visibleDots.length) return;

      const index = Math.min(
        Math.round(this.track.scrollLeft / this.track.clientWidth),
        visibleDots.length - 1
      );
      this.dots.forEach((dot) =>
        dot.classList.toggle('product-card__dot--active', dot === visibleDots[index])
      );
    }
  }
  customElements.define('product-card-slides', ProductCardSlides);
}
